import { HStack, Stack, Text } from 'native-base';

import { colors } from '../../../../theme/colors';
import Icon from '../../../Icon';
import { LocationSuggestionItemProps } from './types';

export const LocationSuggestionItem = (props: LocationSuggestionItemProps) => {
  const { data, highlight = false } = props;

  const { label, icon } = data;

  return (
    <HStack alignItems={'center'}>
      {icon && (
        <Stack borderWidth={1} mr={3}>
          <Icon icon={icon} size={16} color={colors.gray[400]} />{' '}
        </Stack>
      )}
      <Text
        fontSize={'sm'}
        lineHeight={'150%'}
        fontWeight={!highlight ? 400 : 500}
        color={colors.darkText}
        numberOfLines={1}
      >
        {label}
      </Text>
    </HStack>
  );
};

export default LocationSuggestionItem;
